<script>
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  data() {
    let beforeLabel = this.labelBeforeValue;
    let afterLabel = this.labelAfterValue;
    return {
      chart_options: {
        tooltips: {
          enabled: true,
          mode: "index",
          intersect: false,
          legend: {
            display: true,
          },
        },
        scales: {
          yAxes: [
            {
              stacked: true,
              ticks: {
                //beginAtZero: true,
                callback: function (value, index, values) {
                  return beforeLabel + value + afterLabel;
                },
              },
            },
          ],
          xAxes: [
            {
              stacked: true,
            },
          ],
        },
        responsive: true,
        maintainAspectRatio: false,
      },
      datas: {},
    };
  },
  mounted() {
    this.fetchDatas();
    // Overwriting base render method with actual data.
  },
  methods: {
    changeUrl(newUrl) {
      this.url = newUrl;
      this.fetchDatas();
    },

    fetchDatas() {

      var url = this.url;
      if (this.stringParameters != null && this.stringParameters != "") {
        url += "?" + this.stringParameters;
      }

      axios.get(url).then((response) => {
        this.datas = response.data;
        this.renderChart(this.datas, this.chart_options);
      });
    },
  },
  props: {
    url: {
      type: String,
      required: true,
    },
    stringParameters: {
      type: String,
      required: false,
    },
    labelBeforeValue: {
      type: String,
      required: false,
      default: "",
    },
    labelAfterValue: {
      type: String,
      required: false,
      default: "",
    },
  },
};
</script>
